import {
  AlertCircle,
  CheckCircle2,
  FileQuestion,
  LoaderCircle,
  RefreshCw,
} from "lucide-react";

// 共享组件统一三类工作台的加载、错误、空状态及服务状态视觉语义。
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  meta,
}) {
  return (
    <header className="page-header">
      <div className="page-heading">
        {eyebrow ? <p className="page-eyebrow">{eyebrow}</p> : null}
        <h1>{title}</h1>
        {description ? <p className="page-description">{description}</p> : null}
        {meta ? <div className="page-meta">{meta}</div> : null}
      </div>
      {actions ? <div className="page-actions">{actions}</div> : null}
    </header>
  );
}

export function MetricStrip({ items }) {
  return (
    <section className="metric-strip" aria-label="关键数据">
      {items.map((item) => (
        <div className="metric-item" key={item.label}>
          <span>{item.label}</span>
          <strong>{item.value}</strong>
          {item.note ? <small>{item.note}</small> : null}
        </div>
      ))}
    </section>
  );
}

export function LoadingState({ label = "正在读取数据" }) {
  return (
    <div className="state-panel" role="status">
      <LoaderCircle className="spin" size={22} aria-hidden="true" />
      <strong>{label}</strong>
      <div className="skeleton-lines" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="state-panel error-state" role="alert">
      <AlertCircle size={24} aria-hidden="true" />
      <strong>数据暂时不可用</strong>
      <p>{message}</p>
      {onRetry ? (
        <button className="secondary-button" type="button" onClick={onRetry}>
          <RefreshCw size={16} aria-hidden="true" />
          重新读取
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="state-panel empty-state">
      <FileQuestion size={26} aria-hidden="true" />
      <strong>{title}</strong>
      {description ? <p>{description}</p> : null}
      {action || null}
    </div>
  );
}

export function ServiceBadge({ online, checking = false, label }) {
  const text = label || (checking ? "正在检测" : online ? "服务已连接" : "本地模式");
  return (
    <span className={online ? "service-badge online" : "service-badge offline"}>
      {online ? <CheckCircle2 size={13} aria-hidden="true" /> : <AlertCircle size={13} aria-hidden="true" />}
      {text}
    </span>
  );
}
